import { useTheme } from "@emotion/react"
import styled from "@emotion/styled"
import { theme, hexToHSL } from "@pallet-hq/hegel"
import { useEffect, useRef, useState } from "react"
import { useMousePosition } from "utils/hooks/useMousePosition"

export const QuarterCircleAnimatedPattern = () => {
    // @ts-ignore
    const { colors } = useTheme()
    const [h, s] = hexToHSL(colors.primary)
    const patternRef = useRef<any>(null)
    const mousePosition = useMousePosition()
    const [relativePosition, setRelativePosition] = useState({ x: 0, y: 0 })

    useEffect(() => {
        const { x, y } = mousePosition
        let box = patternRef.current!.getBoundingClientRect()
        let bTop = box.top
        let bLeft = box.left

        setRelativePosition({
            x: x - bLeft,
            y: y - bTop,
        })
    }, [mousePosition])

    return (
        <Wrapper
            css={{
                background: `hsl(${h},${s}%,10%)`,
            }}
        >
            <Pattern
                className="pattern"
                x={relativePosition.x}
                y={relativePosition.y}
                viewBox="0 0 549 565"
                width="100%"
                fill="none"
                stroke="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    opacity="0.25"
                    d="M137.961 564.4V561.315C137.999 529.12 141.75 497.037 149.14 465.704H290.895C279.738 496.33 274.045 528.682 274.078 561.284V564.369H275.078V561.284V561.283C275.045 528.676 280.761 496.321 291.96 465.704H449.268H449.762C437.759 478.122 428.198 492.698 421.586 508.672C414.682 525.352 411.129 543.229 411.129 561.284V564.369H412.129V561.284C412.129 543.361 415.656 525.613 422.51 509.055C429.363 492.496 439.409 477.451 452.072 464.779C464.736 452.107 479.769 442.056 496.314 435.2C512.859 428.344 530.591 424.817 548.498 424.821L548.498 423.821C530.46 423.817 512.597 427.37 495.931 434.276C479.265 441.182 464.121 451.307 451.365 464.072C450.828 464.61 450.296 465.152 449.768 465.698V465.204V303.311C481.201 290.778 514.671 284.139 548.507 283.725L548.494 282.725C514.669 283.139 481.208 289.752 449.768 302.235V156.244C482.019 147.766 515.167 143.174 548.507 142.567L548.489 141.567C515.157 142.174 482.016 146.755 449.768 155.21V12.332C482.297 5.81049 515.34 2.18549 548.508 1.49976L548.488 0.5C515.123 1.18976 481.886 4.84833 449.169 11.4323C415.203 18.2701 381.951 28.279 349.851 41.3265C315.061 55.4317 281.786 73.0209 250.532 93.826C183.225 138.6 126.347 197.362 83.7681 266.114C64.2731 297.546 47.963 330.848 35.0806 365.524C23.0705 397.755 14.0842 431.035 8.23779 464.933C2.73582 496.734 -0.0200962 528.949 0.000110309 561.222V564.308H1.00011V561.222L1.00011 561.222C0.980049 529.209 3.69637 497.253 9.11963 465.704H148.113C140.741 497.039 136.999 529.121 136.961 561.314V561.315V564.4H137.961ZM148.348 464.704H9.29224C15.1025 431.162 23.9928 398.228 35.8505 366.322L184.891 366.351C168.627 397.466 156.349 430.511 148.348 464.704ZM84.3565 267.063C65.1151 298.148 48.992 331.061 36.2226 365.322L185.416 365.351C222.959 294.408 279.936 235.652 349.665 195.976V42.4812C315.225 56.4884 282.276 73.9181 251.311 94.5087V266.563V267.063H250.811H84.3565ZM84.9764 266.063C127.276 197.945 183.651 139.678 250.311 95.1748V266.063H84.9764ZM349.665 197.127C280.48 236.618 223.915 294.953 186.548 365.352L349.665 365.384V197.127ZM350.665 42.0752V195.41C381.536 177.979 414.503 164.559 448.768 155.474V12.5334C415.225 19.3245 382.384 29.2144 350.665 42.0752ZM350.665 365.884V196.558C381.527 179.078 414.495 165.619 448.768 156.508V302.634C412.703 317.168 380.068 339.08 352.952 366.969C325.807 394.888 304.794 428.179 291.262 464.704H149.375C157.398 430.505 169.71 397.458 186.02 366.352L350.165 366.384L350.665 366.384V365.884ZM292.329 464.704C305.817 428.446 326.707 395.397 353.669 367.666C380.594 339.973 412.981 318.195 448.768 303.713V464.704H292.329Z"
                    fill="url(#paint0_linear_1189_9984)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_1189_9984"
                        x1="274.254"
                        y1="564.4"
                        x2="274.254"
                        y2="0.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFEFA2" />
                        <stop offset="1" stopColor="#F8C943" opacity="0.6" />
                    </linearGradient>
                </defs>
            </Pattern>
            <BackgroundPattern
                className="pattern"
                viewBox="0 0 548 564"
                width="100%"
                fill="none"
                stroke="none"
                xmlns="http://www.w3.org/2000/svg"
                ref={patternRef}
            >
                <g style={{ mixBlendMode: "soft-light", opacity: 0.7 }}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M137.461 564.4V561.315C137.499 529.12 141.25 497.037 148.64 465.704H290.395C279.238 496.33 273.545 528.682 273.578 561.284V564.369H274.578V561.284V561.283C274.545 528.676 280.261 496.321 291.46 465.704H448.768H449.262C437.259 478.122 427.698 492.698 421.086 508.672C414.182 525.352 410.629 543.229 410.629 561.284V564.369H411.629V561.284C411.629 543.361 415.156 525.613 422.01 509.055C428.863 492.496 438.909 477.451 451.572 464.779C464.236 452.107 479.269 442.056 495.814 435.2C512.359 428.344 530.091 424.817 547.998 424.821L547.998 423.821C529.96 423.817 512.097 427.37 495.431 434.276C478.765 441.182 463.621 451.307 450.865 464.072C450.328 464.61 449.796 465.152 449.268 465.698V465.204V303.311C480.701 290.778 514.171 284.139 548.007 283.725L547.994 282.725C514.169 283.139 480.708 289.752 449.268 302.235V156.244C481.519 147.766 514.667 143.174 548.007 142.567L547.989 141.567C514.657 142.174 481.516 146.755 449.268 155.21V12.332C481.797 5.81049 514.84 2.18549 548.008 1.49976L547.988 0.5C514.623 1.18976 481.386 4.84833 448.669 11.4323C414.703 18.2701 381.451 28.279 349.351 41.3265C314.561 55.4317 281.286 73.0209 250.032 93.826C182.725 138.6 125.847 197.362 83.2681 266.114C63.7731 297.546 47.463 330.848 34.5806 365.524C22.5705 397.755 13.5842 431.035 7.73779 464.933C2.23582 496.734 -0.520096 528.949 -0.49989 561.222V564.308H0.50011V561.222L0.50011 561.222C0.480049 529.209 3.19637 497.253 8.61963 465.704H147.613C140.241 497.039 136.499 529.121 136.461 561.314V561.315V564.4H137.461ZM147.848 464.704H8.79224C14.6025 431.162 23.4928 398.228 35.3505 366.322L184.391 366.351C168.127 397.466 155.849 430.511 147.848 464.704ZM83.8565 267.063C64.6151 298.148 48.492 331.061 35.7226 365.322L184.916 365.351C222.459 294.408 279.436 235.652 349.165 195.976V42.4812C314.725 56.4884 281.776 73.9181 250.811 94.5087V266.563V267.063H250.311H83.8565ZM84.4764 266.063C126.776 197.945 183.151 139.678 249.811 95.1748V266.063H84.4764ZM349.165 197.127C279.98 236.618 223.415 294.953 186.048 365.352L349.165 365.384V197.127ZM350.165 42.0752V195.41C381.036 177.979 414.003 164.559 448.268 155.474V12.5334C414.725 19.3245 381.884 29.2144 350.165 42.0752ZM350.165 365.884V196.558C381.027 179.078 413.995 165.619 448.268 156.508V302.634C412.203 317.168 379.568 339.08 352.452 366.969C325.307 394.888 304.294 428.179 290.762 464.704H148.875C156.898 430.505 169.21 397.458 185.52 366.352L349.665 366.384L350.165 366.384V365.884ZM291.829 464.704C305.317 428.446 326.207 395.397 353.169 367.666C380.094 339.973 412.481 318.195 448.268 303.713V464.704H291.829Z"
                        fill="url(#paint0_linear_1189_9881)"
                    />
                </g>
                <defs>
                    <linearGradient
                        id="paint0_linear_1189_9881"
                        x1="273.754"
                        y1="564.4"
                        x2="273.754"
                        y2="0.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFEFA2" />
                        <stop offset="1" stopColor="#F8C943" />
                    </linearGradient>
                </defs>
            </BackgroundPattern>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    max-width: 450px;
    aspect-ratio: 1 / 1;
    background-color: ${theme.colors.gold900};
`

const Pattern = styled.svg`
    clip-path: ${({ x, y }) => `circle(200px at ${x}px ${y}px)`};
    position: absolute;
    bottom: 0;
    right: 0;
`

const BackgroundPattern = styled.svg`
    position: absolute;
    bottom: 0;
    right: 0;
`
